module.exports = __webpack_public_path__ + "img/amex.3a7c22ff.svg";